import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class QfundTransactionsService {
    private _baseApiUrl: string = '';

    public constructor(
        private appService: AppService,
        public http: HttpClient,
        @Inject('API_BASE_URL') baseurl: string,
    ) {
        this._baseApiUrl = baseurl;
    }

    getQfundPostsReport = (
        creditorId: string,
        fromDate: Date,
        toDate: Date,
    ): Observable<any> => {
        const apipath: string =
            'reports/QFundTransactions/creditor/' +
            creditorId +
            '?fromDate=' +
            moment(fromDate).format('YYYY-MM-DD') +
            '&toDate=' +
            moment(toDate).format('YYYY-MM-DD');
        const fullPath: string = this._baseApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        return this.http.get<any>(fullPath, options);
    };

    downloadQfundPostsReport = (
        creditorId: string,
        fromDate: Date,
        toDate: Date,
    ): Observable<Blob | null> => {
        let result: BehaviorSubject<Blob | null> =
            new BehaviorSubject<Blob | null>(null);
        const apipath: string =
            'reports/QFundTransactions/creditor/' +
            creditorId +
            '/download' +
            '?fromDate=' +
            moment(fromDate).format('YYYY-MM-DD') +
            '&toDate=' +
            moment(toDate).format('YYYY-MM-DD');
        const fullPath: string = this._baseApiUrl + apipath;
        const options = {
            ...this.appService.getHttpHeaderOptions(),
            responseType: 'blob' as 'json',
        };

        this.http.get(fullPath, options).subscribe(
            (blob: any) => {
                result.next(blob);
                result.complete();
            },
            (error) => {
                result.next(error);
            },
        );
        return result;
    };

    getQFundDiscrepancies = (creditorIds: string, startDate: Date) => {
        const apipath: string =
            'reports/QFundTransactions/Discrepancy?creditorIds=' +
            creditorIds +
            '&StartDate=' +
            moment(startDate).format('YYYY-MM-DD');
        const fullPath: string = this._baseApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        return this.http.get<any>(fullPath, options);
    };

    public manualSync = (id: any): Observable<HttpEvent<number>> => {
        let result: BehaviorSubject<number> = new BehaviorSubject<number>(0);
        const apiPath: string =
            'reports/QFundTransactions/Discrepancy/ManualSync';
        const fullPath: string = this._baseApiUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        const params: any = { id };

        return this.http.post<any>(fullPath, params, options);
    };
}
